<template>
  <Accordion title="Reset Password" :isOpenInitially="true">
    <div class="mt-4 p-2">
      <form @submit.prevent="handleSubmit">
        <div class="flex flex-col lg:flex-row items-center gap-4 w-full">
          <!-- Matric Number -->
          <div class="w-full">
            <label for="matricNumber" class="block text-sm font-medium">Matric Number</label>
            <input
              type="text"
              id="matricNumber"
              v-model="matricNumber"
              class="mt-1 p-2 block w-full border rounded"
              required
            readonly
            />
          </div>

          <!-- Password with Visibility Toggle -->
          <div class="w-full relative">
            <label for="password" class="block text-sm font-medium">New Password</label>
            <input
              :type="showPassword ? 'text' : 'password'"
              id="password"
              v-model="password"
              class="mt-1 p-2 pr-10 block w-full border rounded"
              required
            />
            <button
              type="button"
              @click="showPassword = !showPassword"
              class="absolute right-2 top-[38px] text-sm text-gray-500 focus:outline-none"
            >
              {{ showPassword ? 'Hide' : 'Show' }}
            </button>
          </div>
        </div>

        <!-- Submit Button -->
        <button
          type="submit"
          :disabled="isLoading"
          class="bg-primary text-white px-4 mt-3 py-2 rounded hover:bg-primary disabled:opacity-50"
        >
          {{ isLoading ? 'Resetting...' : 'Reset Password' }}
        </button>
      </form>
    </div>
  </Accordion>
</template>

<script setup lang="ts">
import { studentResetPassword } from '@/graphql';
import { useToast } from 'primevue/usetoast';
import { useUserQuery } from '@/composables/queries/useUserQuery';

const {  studentProfile } = useUserQuery();

const matricNumber = ref('');
const password = ref('');
const showPassword = ref(false); // 👈 Toggle visibility
const isLoading = ref(false);
const toast = useToast();

// Prefill matric number when studentProfile is ready
watchEffect(() => {
  if (studentProfile.value?.matric_no) {
    matricNumber.value = studentProfile.value.matric_no;
  }
});

const { mutate: studentResetPasswordMutation } = studentResetPassword();

const handleSubmit = async() => {
  isLoading.value = true;
  try {
    const result = await studentResetPasswordMutation({
      matricNumber: matricNumber.value,
      password: password.value,
    });

    if (result?.data?.studentResetPassword?.success) {
      toast.add({ severity: 'success', summary: 'Success', detail: 'Password reset successfully', life: 3000 });
      password.value = '';
    }
  } catch (error) {
    const err = error as Error;
    toast.add({ severity: 'error', summary: 'Error', detail: err.message || 'Failed to reset password', life: 3000 });
  } finally {
    isLoading.value = false;
  }
};
</script>
